import Swiper, {EffectFade} from 'swiper';
let mySwiper;

mySwiper = new Swiper('.section-newsroom .tabs-content', {
    modules: [EffectFade],
    loop: false,
    slidesPerView: 1,
    keyboardControl: false,
    updateOnWindowResize: true,
    grabCursor: false,
    effect: 'fade',
    autoHeight: true,
    allowTouchMove: false,
    fadeEffect: {
        crossFade: true
    },
});

$(window).resize(function () {
    mySwiper.updateAutoHeight(300);
});

$('.section-newsroom .item-tab').on('click', function (e) {
    if ($(this).hasClass('-active')) return;
    let this_numb = $(this).data('tab');
    $(this).closest('.section-newsroom').find('.item-tab').removeClass('-active');
    $(this).addClass('-active');
    mySwiper.slideTo(this_numb);
    mySwiper.updateAutoHeight(300);
});

let page_news = 1;
let page_events = 1;
let range = 8;
let loading = false;

$(".section-newsroom .load-more-btn").on("click", function () {
    if (!loading) {
        loading = true;
        let section = $(this).closest(".posts-wrap");
        let type = section.data('posts');
        let parent = section.find(".posts-box");
        let target = section.find(".load-more-box");
        let page;
        if (type === 'news') {
            page = page_news;
        } else {
            page = page_events;
        }


        target.addClass("-loading");

        $.ajax({
            url: ajaxMeta.ajaxurl,
            type: "post",
            data: {
                action: "more_news_ajax",
                offset: (page * range),
                range: range,
                type: type,
            },
            success: function (data) {
                if (data.result) {
                    if (type === 'news') {
                        page_news++;
                    } else {
                        page_events++;
                    }

                    loading = false;
                    parent.append(data.result);
                    mySwiper.updateAutoHeight(300);

                    if (data.count <= range) {
                        section.find(".load-more-box").addClass("-hidden");
                    } else {
                        section.find(".load-more-box").removeClass("-hidden");
                    }
                    target.removeClass("-loading");
                } else {
                    loading = false;
                    target.removeClass("-loading");
                }
            }
        });
    }
});
